<div class="fixed inset-0 z-50 bg-black bg-opacity-20 flex items-center justify-center p-4">
    
    <div class="relative w-3/4 h-5/6  max-h-[80vh] bg-gray-800 rounded-xl shadow-2xl flex flex-col items-center justify-center p-6">
        
        <button 
            (click)="close.emit()" 
            class="absolute top-4 right-4 text-white text-3xl p-3 rounded-full bg-transparent hover:bg-white hover:text-gray-900 transition-all duration-300 shadow-xl z-50 focus:outline-none"
            aria-label="Close image viewer"
        >
            <span class="font-light leading-none">&times;</span> 
        </button>

        <div class="relative w-full h-full overflow-hidden flex items-center justify-center">
            <img 
                [src]="imageUrl" 
                [style.transform]="'scale(' + zoomLevel + ')'" 
                class="max-w-full max-h-full transition-transform duration-300 ease-in-out object-contain" 
                alt="Viewer content"
            />
        </div>

        <div class="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-50">
            <div class="flex rounded-full bg-gray-700 bg-opacity-70 backdrop-blur-sm p-1 shadow-xl border border-gray-600">
                
                <button 
                    (click)="zoomIn()" 
                    class="text-white text-2xl w-10 h-10 flex items-center justify-center rounded-full transition-all duration-200 
                           hover:bg-primary_Bg_Button_Color hover:text-primary_Bg_Btn_Text_color hover:shadow-lg focus:outline-none"
                    aria-label="Zoom in"
                >
                    <span class="font-semibold leading-none">+</span>
                </button>
                
                <div class="w-px bg-gray-600 self-stretch my-1 mx-1"></div>

                <button 
                    (click)="zoomOut()" 
                    class="text-white text-2xl w-10 h-10 flex items-center justify-center rounded-full transition-all duration-200 
                           hover:bg-primary_Bg_Button_Color hover:text-primary_Bg_Btn_Text_color hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                    aria-label="Zoom out"
                >
                    <span class="font-semibold leading-none">&minus;</span>
                </button>
            </div>
        </div>
    </div>
</div>